/**
 * @date 2022-03-20
 * @description 日常活动-素材策略or品店策略【内含模块：(商品策略-商运)】
 */
import React from 'react';
import DaliyGoodsStrategy from './daily-goods-strategy';
import './index.less';

export default function DailyMaterialPoolManage() {
  return (
    <div className="daily-material-pool-manage-wrapper" style={{ padding: '24px' }}>
      {/* 商品策略 */}
      <div className="daily-strategy-fa">
        {/* 商品策略 */}
        <div className="daily-goods-strategy-fa">
          <DaliyGoodsStrategy />
        </div>
        {/* 店铺策略 - 待拓展 */}
        <div className="daily-shop-strategy-fa">
          <div className="daily-shop-strategy-wrapper">
            <div className="daily-shop-strategy-icon">
              <img
                src="//img30.360buyimg.com/pop/jfs/t1/195079/6/22072/5984/6241a8b1E3e084a0a/920f0c09b13b830e.png"
                width={80}
                height={80}
              />
            </div>
            <div className="daily-shop-strategy-main">目前仅有商品策略，店铺策略还在建设中，敬请期待~</div>
          </div>
        </div>
      </div>
    </div>
  );
}
